import { swatchBoxSX, swatchSX } from '@/components/blocks/Swatch/style';
import { useImagePath } from '@/data/Content/_ImagePath';
import { combineSX } from '@/utils/combineSX';
import { Box, IconButton, IconButtonProps } from '@mui/material';
import { FC } from 'react';
import { HCLSTORE_PATH } from 'shared/custom/constants/commonConstants';

type SwatchProps = IconButtonProps & {
	selected?: boolean;
	image?: string;
};

export const Swatch: FC<SwatchProps> = ({
	selected = false,
	image: img = '',
	sx,
	onClick,
	...props
}) => {
	const attrImage = 'https://' + img.replace(HCLSTORE_PATH, '');
	const image = useImagePath(attrImage);
	return (
		<Box sx={swatchBoxSX({ selected })}>
			<IconButton
				size="large"
				sx={combineSX([swatchSX({ selected, image, clickable: !!onClick }), sx])}
				onClick={onClick}
				{...props}
			></IconButton>
		</Box>
	);
};
